<script setup lang="ts">
import { computed, ref } from "vue";
import { usePdf } from "#/composables/usePdfMode";
import { vDragScroll } from "#/directives/vDragScroll";
import UseScrollCenter from "../../hooks/useScrollToCenter/UseScrollCenter.vue";

const props = withDefaults(
	defineProps<{
		menuTags: string[];
		groupIndex?: number | null;
		isSolo?: boolean;
		currentActiveTag: any;
		activeTakeTags?: (tag: string, groupIndex: number) => void;
		activeTakeTagsSolo?: (tag: string) => void;
	}>(),
	{
		menuTags: () => [],
		isSolo: false,
		groupIndex: null,
		activeTakeTags: undefined,
		activeTakeTagsSolo: undefined,
	},
);

const { shouldUseDragScroll } = usePdf();

const scrollTagContainer = ref<HTMLElement | null>(null);

const updateActiveTag = computed<string[]>(() => {
	if (props.isSolo && !props.groupIndex) {
		return Array.isArray(props.currentActiveTag) ? props.currentActiveTag : [];
	}

	if (props.groupIndex !== null && props.groupIndex !== undefined) {
		const tags = props.currentActiveTag[props.groupIndex];
		return Array.isArray(tags) ? tags : [];
	}

	return [];
});
</script>

<template>
	<ul class="main__filters" ref="scrollTagContainer" v-drag-scroll="shouldUseDragScroll ? {} : false" v-if="menuTags.length > 0">
		<UseScrollCenter
			axis="x"
			behavior="smooth"
			:container="scrollTagContainer"
			:autoScroll="true"
			:idActive="updateActiveTag ? updateActiveTag[currentActiveTag.length - 1] : null"
			:clearContainer="false"
		>
			<template #default="{ handleTargetClick }">
				<li
					v-for="(tag, index) in menuTags"
					:key="index"
					:id="`scrolling${tag}`"
					@click="(e: any) => {
            if (activeTakeTags && (groupIndex || groupIndex === 0)) activeTakeTags(tag, groupIndex);
            else if(activeTakeTagsSolo) activeTakeTagsSolo(tag)
            handleTargetClick(e);
          }"
					:class="{ 'main__filter_active': (updateActiveTag ?? []).includes(tag) }"
				>
					{{ tag }}
				</li>
			</template>
		</UseScrollCenter>
	</ul>
</template>

<style scoped lang="scss">
  @use './tagsMain.scss';
</style>
